import {
    fadeIn,
} from '@js/common/all-functions.js';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const issSldier = document.querySelectorAll('.interactive-sector-section');

    issSldier.forEach(section => {
        const issTabSldier = section.querySelector('.iss-tab-slider');
        const issContentSldier = section.querySelector('.iss-content-slider');

        const mainTabSwiper = new Swiper(issTabSldier, {
            slidesPerView: 'auto',
            spaceBetween: 34,
            navigation: {
                prevEl: issTabSldier.parentNode.querySelector('.iss-tab-arrow-prev'),
                nextEl: issTabSldier.parentNode.querySelector('.iss-tab-arrow-next'),
            },
        });

        const mainContentSwiper = new Swiper(issContentSldier, {
            slidesPerView: 1,
            spaceBetween: 24,
            effect: 'fade',
            autoHeight: true,
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                prevEl: issContentSldier.parentNode.querySelector('.iss-arrow-prev'),
                nextEl: issContentSldier.parentNode.querySelector('.iss-arrow-next'),
            },
            pagination: {
                el: issContentSldier.parentNode.querySelector('.iss-pagination'),
                type: 'fraction',
                renderFraction: function(currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span> - <span class="' + totalClass + '"></span>';
                },
                formatFractionCurrent: function(number) {
                    return number < 10 ? '0' + number : number;
                },
                formatFractionTotal: function(number) {
                    return number < 10 ? '0' + number : number;
                },
            },
        });

        // Add click handlers to iss-tab-item inside this section
        const cpqCards = section.querySelectorAll('.iss-tab-item');
        const items = section.querySelectorAll('.iss-img-item');

        cpqCards.forEach((card, index) => {
            card.addEventListener('click', () => {
                const targetId = card.getAttribute('data-href');

                if (!card.classList.contains('is-active')) {
                    cpqCards.forEach(c => c.classList.remove('is-active'));
                    card.classList.add('is-active');

                    items.forEach(item => {
                        if (item.getAttribute('data-id') === targetId) {
                            fadeIn(item);
                            item.classList.add('is-active');
                        } else {
                            item.style.display = 'none';
                            item.classList.remove('is-active');
                        }
                    });
                }

                mainContentSwiper.slideTo(index);
            });
        });

        const imgItems = section.querySelectorAll('.iss-img-item');
        const contentSidebar = section.querySelector('.iss-content-sidebar');

        imgItems.forEach(item => {
            const dragElements = item.querySelectorAll('.drag_element');
            dragElements.forEach(dragEl => {
                dragEl.addEventListener('click', () => {
                    if (contentSidebar) {
                        contentSidebar.classList.add('is-show');
                    }
                });
            });
        });

        const closeBtns = section.querySelectorAll('.iss-content-sidebar .close-btn, .iss-content-sidebar .iss-overlay');
        if (contentSidebar && closeBtns.length) {
            closeBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    contentSidebar.classList.remove('is-show');
                });
            });
        }

        mainContentSwiper.on('slideChange', () => {
            const currentIndex = mainContentSwiper.activeIndex;

            cpqCards.forEach(c => c.classList.remove('is-active'));
            if (cpqCards[currentIndex]) {
                cpqCards[currentIndex].classList.add('is-active');
            }

            // Also update visible image items if needed
            const targetId = cpqCards[currentIndex] ?.getAttribute('data-href');
            items.forEach(item => {
                item.style.display = item.getAttribute('data-id') === targetId ? fadeIn(item) : 'none';
            });

            // Slide tab slider to active tab to keep it visible
            mainTabSwiper.slideTo(currentIndex);
        });
    });
});
